<template>
    <div>
        <div style="text-align:center;width: 50%;margin: 0 auto;">
            <h1>Water Usage</h1>
              <p>
                  At Waters Contracting we take water conservation very seriously.
                  We specialize in many services related to water conservation such as auditing and water effecient landscape design.
                  We even have an android app to help you determine when to water your landscaping.
              </p>
              <b-card
                title="Landscape Watering Guide for Android"
                img-src="../assets/guide.png"
                img-alt="Landscape Watering Guide Logo"
                img-bottom
                tag="article"
                class="mb-2"
              >
                <b-card-text>
                  Have you ever wondered how much water you need for your landscape?

Landscape watering guide: This app allows you to easily see how much your landscape needs to be watered. Using your location, the app will provide a guide on how much you need to water per week. This simple app will help you save water and properly water your lawn.

Landscape watering guide uses local weather services to determine the temperature, weather, and more. It shows the weather for the next 7 days. The guide provides information for watering provided and used by certified contractors at Waters Contracting. Note: this is a guide, different systems could use more or less water.
                </b-card-text>
                 <b-button href="#" variant="primary">Download Now</b-button>
              </b-card>
        </div>
    </div>
</template>

<script>
export default {
  name: 'WaterUsage',
}
</script>